// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// if the value is less than 10, add a leading zero
// so we always have HH:MM:SS. None of that H:MM:S nonsense.
const addLeadingZero = v => (
  v > 9
    ? `${v}`
    : `0${v}`
)

export default addLeadingZero
